import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import zhCN from "antd/locale/zh_CN";
import { useAuth } from "./stores/auth";
import MainLayout from "./components/Layout";
import LoginPage from "./pages/Login";
import CaseListPage from "./pages/CaseList";
import CaseCreatePage from "./pages/CaseCreate";
import CaseHandlePage from "./pages/CaseHandle";
import CaseDetailPage from "./pages/CaseDetail";

function PrivateRoute({
  children,
  auth,
}: {
  children: React.ReactNode;
  auth: ReturnType<typeof useAuth>;
}) {
  if (auth.loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (!auth.user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  const auth = useAuth();

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#1890ff",
          borderRadius: 8,
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              auth.user ? (
                <Navigate to="/" replace />
              ) : (
                <LoginPage auth={auth} />
              )
            }
          />
          <Route
            path="/"
            element={
              <PrivateRoute auth={auth}>
                <MainLayout auth={auth} />
              </PrivateRoute>
            }
          >
            <Route index element={<CaseListPage />} />
            <Route path="cases/create" element={<CaseCreatePage />} />
            <Route path="cases/:id" element={<CaseDetailPage />} />
            <Route path="cases/:id/handle" element={<CaseHandlePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
